import React from 'react';

import { Box, Chip, Stack, TextField, Typography } from '@mui/material';

import FormSection from 'components/condition-list/FormSection';

export type ExpenseLabelFormValues = {
  name: string;
  color: string;
};

type Props = {
  values: ExpenseLabelFormValues;
  onChange: (values: ExpenseLabelFormValues) => void;
  /** 参照専用（詳細表示中で未編集）か */
  disabled?: boolean;
  /** name の 422/バリデーションエラー文言 */
  nameError?: string;
};

const NAME_MAX = 64;
const COLOR_MAX = 9;

/**
 * 品目ラベルの作成/更新フォーム（ConditionList の詳細ペイン内で使用）。
 * 名前（必須 max64）＋色（必須 max9・カラーピッカー）。
 */
const ExpenseLabelForm: React.FC<Props> = ({ values, onChange, disabled = false, nameError }) => {
  const setName = (name: string) => onChange({ ...values, name });
  const setColor = (color: string) => onChange({ ...values, color });

  return (
    <Stack spacing={2.5}>
      <FormSection title="品目ラベル">
        <Stack spacing={2}>
          <TextField
            label="ラベル名"
            size="small"
            fullWidth
            required
            disabled={disabled}
            value={values.name}
            onChange={(e) => setName(e.target.value)}
            error={!!nameError}
            helperText={nameError}
            inputProps={{ maxLength: NAME_MAX }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
          />
          <Stack direction="row" spacing={2} alignItems="center">
            <Typography variant="body2" color="text.secondary">
              色
            </Typography>
            <Box
              component="input"
              type="color"
              value={values.color}
              disabled={disabled}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                setColor(e.target.value.slice(0, COLOR_MAX))
              }
              sx={{
                width: 48,
                height: 32,
                border: 1,
                borderColor: 'divider',
                borderRadius: 1,
                p: 0,
                cursor: disabled ? 'default' : 'pointer',
                bgcolor: 'transparent',
              }}
            />
            <Chip
              label={values.name.trim() || 'プレビュー'}
              size="small"
              sx={{
                borderRadius: 1.5,
                color: '#fff',
                bgcolor: values.color,
                fontWeight: 500,
              }}
            />
          </Stack>
        </Stack>
      </FormSection>
    </Stack>
  );
};

export default ExpenseLabelForm;
